import { render, staticRenderFns } from "./UnbindSecgroup.vue?vue&type=template&id=96f07a60"
import script from "./UnbindSecgroup.vue?vue&type=script&lang=js"
export * from "./UnbindSecgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports